import { freeze } from "immer";
import { commonTheme } from "./common-theme";
import { darkTheme } from "./dark-theme";

export const gigaTvTheme = freeze({
    ...commonTheme,
    ...darkTheme
} as const);

export type GigaTvTheme = typeof gigaTvTheme;